import Modal from "react-bootstrap/Modal";
import { useContext } from "react";
import { OrderFlow } from "../../App";
import ThemeContext from "../../common/theme/components/contexts/themecontexts";


function PopupCurrency() {
    const { theme } = useContext(ThemeContext);
    const {  currencyPopup, handleCurrencyChange } = OrderFlow();
    const suggestData = [
        {
            currencyTitle: "Indian Rupee",
            currencyName: "INR",
            currencySymbol: '₹'
        },
        {
            currencyTitle: "Pound Sterlinge",
            currencyName: "GBP",
            currencySymbol: '£'
        },
        {
            currencyTitle: "Euro",
            currencyName: "EUR",
            currencySymbol: '£'
        },
        {
            currencyTitle: "United Arab Emirates Dirham",
            currencyName: "AED",
            currencySymbol: 'د.إ'
        },
        {
            currencyTitle: "Euro",
            currencyName: "EUR",
            currencySymbol: '€'
        },
    ];
    const Symbol=localStorage.getItem("currencyName");
    return (
        <>
            <Modal
                centered
                size="lg"
                show={currencyPopup}
                className={`currency_popup ${theme === "dark" ? "dark-theme" : ""}`}
                backdrop="static"
                keyboard={false}
                id="loginpopups"
            >
                <Modal.Header closeButton className="currency_popup_header">
                    <Modal.Title className="currency_popup_modal-title">Select your currency</Modal.Title>
                </Modal.Header>
                <Modal.Body className="currency_popup_body">
                    <>
                        <div className="currency_popup_des">Where applicable, prices will be converted to—and shown in—the currency you select. The currency you pay in may differ based on your reservation, and a service fee may also apply.</div>
                        <div className="currency_popup_title">Suggested for you</div>
                        <div className="currency_popup_all">
                            {suggestData.map((v, i) => (
                                <div key={i} className={`currency_popup_item ${v.currencyName == Symbol ?"active":''}`} onClick={() => handleCurrencyChange(v)}>
                                    <div className="currency_popup_subtitle">{v.currencyTitle}</div>
                                    <div className="currency_popup_Symbol">{v.currencyName}</div>
                                </div>
                            ))}
                        </div>
                        <AllCurrencies />
                    </>
                </Modal.Body>
            </Modal>
        </>
    );
}

const AllCurrencies = () => {
    const suggestData1 = [
        {
            currencyTitle: "Indian Rupee",
            currencyName: "INR",
            currencySymbol: '₹'
        },
        {
            currencyTitle: "Pound Sterlinge",
            currencyName: "GBP",
            currencySymbol: '£'
        },
        {
            currencyTitle: "Euro",
            currencyName: "EUR",
            currencySymbol: '£'
        },
        {
            currencyTitle: "United Arab Emirates Dirham",
            currencyName: "AED",
            currencySymbol: 'د.إ'
        },
        {
            currencyTitle: "Euro",
            currencyName: "EUR",
            currencySymbol: '€'
        },
    ]
    return (
        <>
            <div className="currency_popup_title">All currencies</div>
            <div className="currency_popup_all">
                {suggestData1.map((v, i) => (
                    <div key={i} className="currency_popup_item">
                        <div className="currency_popup_subtitle">{v.currencyTitle}</div>
                        <div className="currency_popup_Symbol">{v.currencyName}</div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default PopupCurrency;

// export default SignIn;
